import { render, staticRenderFns } from "./TokenPriceRender.vue?vue&type=template&id=2f898890&scoped=true"
import script from "./TokenPriceRender.vue?vue&type=script&lang=ts"
export * from "./TokenPriceRender.vue?vue&type=script&lang=ts"
import style0 from "./TokenPriceRender.vue?vue&type=style&index=0&id=2f898890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f898890",
  null
  
)

export default component.exports